import { ParcelDto, ParcelModel } from '../types/parcel'

export const transformParcelDtoToModel = ({ dimensions, weight }: ParcelDto): ParcelModel => ({
  height: dimensions.height?.toString() || null,
  length: dimensions.length?.toString() || null,
  width: dimensions.width?.toString() || null,
  weight: weight?.toString() || null,
})
